import * as Sentry from '@sentry/browser';
import FinancialsTabs from 'components/financials/financials-tabs';
import { ROUTES } from 'core/routes';
import {
  FinancialsProvider,
  useFinancials,
  useFinancialsActions,
} from 'hooks/financials';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { RouteComponentProps, useLocation } from 'react-router';
import { generatePath, useHistory } from 'react-router-dom';

export enum ReportType {
  Deposits = 'deposits',
  Outstanding = 'outstanding',
  Transactions = 'transactions',
}

export const ReportTypeMapping = {
  deposits: ReportType.Deposits,
  outstanding: ReportType.Outstanding,
  transactions: ReportType.Transactions,
};

const FinancialsPage = ({
  match: {
    params: { orgId },
  },
}: RouteComponentProps<{ orgId: string; seasonId: string }>) => {
  const [currentReport, setCurrentReport] = useState<ReportType>();
  const location = useLocation();
  const history = useHistory();
  const { hasOrgAdminAccess, organization } = useFinancials();
  const { setOrgAdminAccess, getOrganizationByOrgId } = useFinancialsActions();

  useEffect(() => {
    let hasAdminAccess = false;
    if (hasOrgAdminAccess === null) {
      hasAdminAccess = setOrgAdminAccess(orgId);
    } else {
      return;
    }
    const reportFromPath =
      ReportTypeMapping[location.pathname.split('/').at(-1)] ||
      (hasAdminAccess || hasOrgAdminAccess
        ? ReportType.Deposits
        : ReportType.Outstanding);
    setCurrentReport(reportFromPath);
    history.replace(
      generatePath<string>(ROUTES.FINANCIALS, {
        orgId,
        reportType: reportFromPath,
      })
    );
  }, [location.pathname, hasOrgAdminAccess, orgId, history]);

  useEffect(() => {
    if (!organization) {
      getOrganizationByOrgId(+orgId).catch((e) => {
        // TODO: Show notification to user that something went wrong
        Sentry.captureException(e);
      });
    }
  }, [orgId]);

  return (
    <div id="financials" className="container hub-full-width">
      <div className="page-content u-xs-padXl u-flexExpandSides">
        <div className="page-content-header Grid u-padBottomSm u-flexAlignItemsCenter sui-mb-0">
          <div className="Grid-cell u-xs-size1of2">
            <h1>Financials</h1>
          </div>
        </div>
        <div className="page-content-body u-padBottomXxl">
          <FinancialsTabs
            currentReport={currentReport}
            setCurrentReport={setCurrentReport}
          />
        </div>
      </div>
    </div>
  );
};

const WrappedFinancialsPage = (props) => (
  <FinancialsProvider>
    <FinancialsPage {...props} />
  </FinancialsProvider>
);

export default WrappedFinancialsPage;
